import { Card, Badge, Typography } from "antd";
import {
    FileAddOutlined,
    FileSearchOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { type CSSProperties } from "react";

const { Title } = Typography;

const page: CSSProperties = {
    padding: "0px 28px 20px",
    height: "100%",
    boxSizing: "border-box",
    background: "#f6f8fc",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
};

const topTabs: CSSProperties = {
    flex: "0 0 auto",
    display: "flex",
    flexWrap: "wrap",
    gap: "12px 28px",
    margin: "16px 0 16px",
    padding: "12px 24px",
    borderRadius: 20,
    color: "#fff",
    backdropFilter: "blur(20px)",
    background: "#884699",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
};

const tabItem: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "5px 10px",
    cursor: "pointer",
    transition: "all .3s",
};

const tabIcon: CSSProperties = {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
};

const contentCard: CSSProperties = {
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 24,
    border: "none",
    boxShadow: "0 25px 60px rgba(0,0,0,0.08)",
};

// The Outlet child needs a definite height to size a fitted table against, so
// the body has to pass the flex chain through instead of shrink-wrapping.
// `auto` rather than `hidden`: a tab that self-fits never shows a scrollbar,
// but a taller one scrolls here instead of being cut off.
const contentCardBody: CSSProperties = {
    flex: "1 1 auto",
    minHeight: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    padding: 16,
};

const AttachmentLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentPath = location.pathname.replace("/aenquiry/", "");

    const tabs = [
        {
            key: "add-enquiry",
            label: "Attachment Enquiry Managment",
            color: "#b56ac8",
            icon: <FileAddOutlined />,
            count: 0,
        },
        {
            key: "AEnquiry",
            label: "Attachment Enquiry",
            color: "rgba(233, 158, 88, 0.92)",
            icon: <FileSearchOutlined />,
            count: 0,
        },
    ];

    const validTab = tabs.some((t) => currentPath.includes(t.key));
    const currentTab = validTab ? currentPath.split("/")[0] : "";

    return (
        // `fit-shell` lets a page that drops the height fit (see
        // style/fit-table.css) open this wrapper up too - otherwise the page
        // grows inside a box that clips it and never scrolls.
        <div className="fit-shell" style={page}>
            <div style={topTabs}>
                {tabs.map((tab) => {
                    const active = tab.key === currentTab;

                    return (
                        <div
                            key={tab.key}
                            onClick={() => navigate(`/aenquiry/${tab.key}`)}
                            style={{
                                ...tabItem,
                                borderBottom: active
                                    ? `3px solid ${tab.color}`
                                    : "3px solid transparent",
                            }}
                        >
                            <Badge count={tab.count} offset={[5, -5]}>
                                <div
                                    style={{
                                        ...tabIcon,
                                        background: active ? tab.color : "#fff",
                                        color: active ? "#fff" : tab.color,
                                    }}
                                >
                                    {tab.icon}
                                </div>
                            </Badge>

                            <span style={{ fontWeight: active ? 700 : 500 }}>
                                {tab.label}
                            </span>
                        </div>
                    );
                })}
            </div>

            <Card className="fit-shell-card" style={contentCard} styles={{ body: contentCardBody }}>
                <Outlet />
            </Card>
        </div>
    );
};

export default AttachmentLayout;
